<template>
  <div class="close" :class="[type]" slot="right"><img :src="`${require('@/assets/image/base/close/' + logoName)}`" alt=""></div>
</template>
<script type="text/ecmascript-6">
export default {
  props: {
    type: {
      type: String,
      default: ''
    },
    logoName: {
      type: String,
      default: 'close_1.png'
    }
  }
}
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
.close
  @extend .flex-center
  height 100%
  padding-left 20px
  &.small
    img
      width 12px
      height 12px
  &.big{
    img{
      width: 24px;
      height: 24px;
    }
  }
  &.class1
    padding 0
    width 2rem
  &.class2
    position absolute
    top 8px
    right 0
    height auto
    padding 15px
  img
    width 13px
    height 13px
</style>
